// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Toolbar_Logo__3Lk47","Right":"Toolbar_Right__3MkHm","NavFont":"Toolbar_NavFont__nRvyC"};